import React from "react";
import { useMemo } from "react";

export const DOTS = "...";

const range = (start, end) => {
  // takes a start and end value and return an array with elements from start to end
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};
export const usePagination = ({ totalCount, pageSize, currentPage }) => {
  const paginationRange = useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);
    // Always display [currentPage - 1, currentPage, currentPage + 1, currentPage + 2, currentPage + 3]
    // Handle scenarios for first and last few pages separately

    if (totalPageCount <= 5) {
      // if pageCount is under 5 no need for dots ...
      return range(1, totalPageCount);
    }

    // displaying the ranghe and then dots and last pageCount(totalPageCount)
    if (currentPage <= 3) {
      return [...range(1, 4), DOTS, totalPageCount];
    }

    // The inverse of the above, depending on where i am
    if (currentPage > totalPageCount - 3) {
      return [1, DOTS, ...range(totalPageCount - 3, totalPageCount)];
    }

    // Displaying dots and first/last page number when in the middle pages
    return [1, DOTS, ...range(currentPage - 1, currentPage + 3), DOTS, totalPageCount];
  }, [totalCount, pageSize, currentPage]);

  return paginationRange;
};
